import cart from './cart';

export default {
    modules: {
        cart
    }
}